module.exports = __webpack_public_path__ + "assets/79634ae95f7099a6889c42bd3cdd53a1.mp3";